/* eslint-disable react/no-children-prop */
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Input, InputGroup, InputProps, InputRightElement } from "@chakra-ui/react";
import React, { useState } from "react";
import uiConfig from "../config";

export default function PasswordInput(props: InputProps) {
  const [mode, setMode] = useState<"password" | "text">("password");
  const handleClick = () => {
    if (mode === "password") {
      setMode("text");
    } else {
      setMode("password");
    }
  };
  return (
    <InputGroup>
      <Input
        type={mode}
        maxLength={30}
        color="inherit"
        {...props}
        fontSize={uiConfig.inputFontSize}
        _placeholder={{ color: "#C9CDD4", fontSize: uiConfig.inputFontSize }}
      ></Input>
      <InputRightElement
        onClick={handleClick}
        cursor="pointer"
        children={mode === "password" ? <ViewIcon /> : <ViewOffIcon />}
      />
    </InputGroup>
  );
}
